
import {defineComponent} from 'vue';
import axios from 'axios'
import {lookupURL, userSignupURL} from "@/config/app-settings";
import ProfileForm from "@/components/form/ProfileForm.vue";
import {User} from '@/store';
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Checkbox from "primevue/checkbox";
import Message from "primevue/message";
import Button from "primevue/button";

export default defineComponent({
  name: 'Register',
  components: {ProfileForm, Card, InputText, Dropdown, Checkbox, Message, Button},
  data() {
    return {
      publicPath: process.env.BASE_URL,
      user: {} as User,
      showPw: false,
      password: '',
      passwordConfirm: '',
      imageUploadPermissionOptions: null,
      acceptLicense: false,
      state: 'init' as 'init' | 'submitted' | 'success' | 'error',
      booleanOptions: [{ID: 1, LABEL: this.$t('login.' + 'yes')}, {ID: 2, LABEL: this.$t('login.' + 'no')}],
      booleanAnonymousOptions: [{ID: 1, LABEL: this.$t('login.' + 'yes')}, {
        ID: 2,
        LABEL: this.$t('login.' + 'no_anonymous')
      }]
    }
  },
  computed: {
    passwordsMatch(): boolean {
      return this.password === this.passwordConfirm
    },
    passwordValid(): boolean {
      return this.password.length >= 8 && this.password.trim().length === this.password.length
    },
    valid(): boolean {
      return this.acceptLicense && this.passwordsMatch && this.passwordValid
    }
  },
  methods: {
    toLogin() {
      this.$emit('login')
      this.$router.push({name: 'Login'});
    },
    updateUserInfo(value: User) {
      this.user = value
    },
    register() {
      this.state = 'submitted';
      console.log("REGISTER SIGNUP ", this.user)
      axios.post(userSignupURL, {
        email: this.user.email,
        password: this.password,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        street: this.user.street,
        streetNo: this.user.streetNo,
        zip: this.user.zip,
        city: this.user.city,
        country: this.user.country,
        phoneNo: this.user.phoneNo,
        selfEstimation: this.user.selfEstimation,
        imageUploadPermission: this.user.imageUploadPermission,
        restrPublication: this.user.restrPublication,
        userNameRight: this.user.userNameRight,
        certificates: this.user.certificates,
      })
          .then(() => {
                this.state = 'success'
                this.$store.dispatch('validate', {})
              }
          )
          .catch(err => {
            this.state = 'error'
            this.$store.dispatch('validate', err.response.data)
          })
    },
    getImageUploadPermissions() {
      axios.get(lookupURL + 'image_upload_permission?lang=' + this.$store.state.language)
          .then(res => this.imageUploadPermissionOptions = res.data)
          .catch(e => console.log(e))
    },
    setDefaultUserConfig() {
      this.user.selfEstimation = 1 // Anfänger
      this.user.imageUploadPermission = 1 // öffentlich
      this.user.restrPublication = 1 // true (punktgenaue Weitergabe)
      this.user.userNameRight = 1 // true (Name darf veröffentlicht werden)
    }
  },
  beforeMount() {
    this.getImageUploadPermissions()
    this.setDefaultUserConfig()
  }
});
